import { render, staticRenderFns } from "./MediaLibraryDialog.vue?vue&type=template&id=d22b2dfc&scoped=true&"
import script from "./MediaLibraryDialog.vue?vue&type=script&lang=js&"
export * from "./MediaLibraryDialog.vue?vue&type=script&lang=js&"
import style0 from "./MediaLibraryDialog.vue?vue&type=style&index=0&id=d22b2dfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22b2dfc",
  null
  
)

export default component.exports